import { TextInputV2 } from "react-migration/components/TextInputV2";
import { Icon } from "react-migration/components/Icon";
import { useContext, useEffect, useRef, useState } from "react";

import { SiteFiltersContext } from "../SiteFilters";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";

export interface SiteSearchProps {
  className?: string;
}

export const SiteSearch = ({ className }: SiteSearchProps) => {
  const { t } = useTranslation();
  const { onFilterUpdate, useSearchString, updateSearchString } = useContext(SiteFiltersContext);

  const searchString = useSearchString();

  const searchRef = useRef<HTMLInputElement>(null);

  const [value, setValue] = useState(searchString);

  useEffect(() => {
    if (searchString !== value) {
      setValue(searchString);
    }
    // deliberately excluding value here to prevent this effect from running twice
    // because we mutate value as part of the effect
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchString, onFilterUpdate]);

  const onSubmit = () => {
    updateSearchString(value);
    onFilterUpdate("searchText");
    searchRef.current?.blur();
  };

  return (
    <div data-testid="site-search" className={className}>
      <TextInputV2
        ref={searchRef}
        size="small"
        className="md:w-full"
        dataTestId="site-search-input"
        placeholder={t("sites.pipeline.filters.search_for_sites")}
        IconLeft={<Icon icon="icon-lt-search-line" extraClasses="hidden md:block" />}
        iconContainerProps={{
          className: "ml-0 md:ml-3",
        }}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            onSubmit();
            searchRef.current?.blur();
          } else if (e.key === "Escape") {
            setValue(searchString);
            searchRef.current?.blur();
          }
        }}
      />
    </div>
  );
};
